import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import DocumentReady from './document-ready-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <DocumentReady {...validProps} />;
}
SvgComponent.iconName = 'documentReady';

export const DocumentReadyIcon = svgIconWrapper(SvgComponent);
